import '@/assets/css/pikaday.css';
import '@/assets/style/variables.sass';
import Pikaday from 'pikaday';

export default class PikadayService {
    static create(target: string, defaultDate: Date) {
        return new Pikaday({
            field: document.getElementById(target),
            maxDate: new Date(),
            defaultDate,
            i18n: {
                previousMonth: 'Anterior',
                nextMonth: 'Siguiente',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb']
            },
            format: 'DD/MM/YYYY',
            keyboardInput: false,
        });
    }
}